import store from "./store";

export default {
  // To be used when tenant management API returns true values
  GET_USERMANAGEMENT_API_URL: () => store.getState().tenant.tenantInfo.auth.baseUrl,
  GET_DEVICEMANAGEMENT_API_URL: () => store.getState().tenant.tenantInfo.app.baseUrl,
  GET_FOTA_API_URL: () => store.getState().tenant.tenantInfo.app.baseUrl,
  GET_CLIENT_ID: () => store.getState().tenant.tenantInfo.auth.webClientId,
  GET_IAM_API_URL: () => store.getState().tenant.tenantInfo.auth.iamUrl,
  GET_TENANT_ID: () => store.getState().tenant.tenantInfo.tenantId || "panasonic",
};